









































import { Component } from 'vue-property-decorator';
import CBooleanSwitch from '@/components/Helper/Form/CBooleanSwitch.vue';
import CSideBar from '@/components/Layout/SideBar/CSideBar.vue';
import { sidebarConfig } from '@/config/sidebar';
import SettingsIcon from '@/components/Helper/Icon/Svg/SettingsIcon.vue';
import { CompanyEntity } from '@/entities/company.entity';
import SettingMixin from './setting.mixin';

@Component<SettingPc>({
  components: { SettingsIcon, CSideBar, CBooleanSwitch },
})
export default class SettingPc extends SettingMixin {
  company: CompanyEntity = null;
  sideDrawer: boolean = null;

  get sideBarItems() {
    return [
      {
        lang: 'profile.title',
        link: '/setting/profile',
      },
      {
        lang: 'setting.languageSetting',
        link: '/setting/language',
      },
      !this.company?.companyDefault
        ? {
            lang: 'setting.pointSetting',
            link: '/setting/point',
          }
        : {},
      // {
      //   lang: 'setting.notificationSetting',
      //   link: '/setting/notification',
      // },
      {
        lang: 'setting.passwordSetting',
        link: '/setting/password',
      },
    ];
  }

  sidebarConfig = sidebarConfig;

  tab = 0;

  get tabs() {
    return [
      this.$t('setting.languageSetting'),
      this.$t('setting.notificationSetting'),
      this.$t('setting.pointSetting'),
      this.$t('setting.passwordSetting'),
      this.$t('profile.avatarTitle'),
      this.$t('profile.informationTitle'),
    ];
  }

  get containerWidth() {
    return this.$vuetify.breakpoint.mobile
      ? '100%'
      : `calc(100% - ${sidebarConfig.width}px - 48px)`;
  }
  async created() {
    const { data } = await this.$http.get(`company/${this.currentStaff.companyId}`);
    this.company = data;
  }
}
